import {Injectable} from '@angular/core';
import {CustomizeHttpUrlGenerator} from '../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from '../../../../core/service/v2/service/action/abstractAction.service';
import {ChargedActSetCompletedPayload} from './payload/chargedActSetCompleted.payload';
import {ChargedActDataServiceAdapter} from "./ngrx/chargedActDataService.adapter";
import {ChargedActRepository} from "./ngrx/chargedAct.repository";

@Injectable()
export class ChargedActSetCompletedService extends AbstractActionService<ChargedActSetCompletedPayload, any> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private chargedActDataServiceAdapter: ChargedActDataServiceAdapter,
                       private chargedActRepository: ChargedActRepository) {
        super('ChargedAct', 'set-completed', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): any {
        const storedEntity = this.chargedActDataServiceAdapter.buildStoredEntityEntity(response);
        this.chargedActRepository.updated(storedEntity);
        return storedEntity;
    }
}
